import React, { useContext } from 'react';
import styled from 'styled-components';
import AlertDialog from 'ls-common-client/dist/components/AlertDialog';
import { Context } from '../../context/AppContext';

const StyledAlertDialog = styled(AlertDialog)`
  .errorButton {
    background-color: #ff585b;
    &:hover {
      background-color: #ff585b;
    }
  }
`;

const AlertPopup = () => {
  const {
    error: { error, setError },
  } = useContext(Context) || {};

  return (
    <StyledAlertDialog
      className="AlertPopup"
      zIndex="9999999999999"
      show={!!error}
      heading={error ? error.heading : 'Oops, something went wrong.'}
      text={error ? error.message : ''}
      buttons={[
        {
          children: 'OK',
          type: 'button',
          props: {
            primary: true,
            rounded: true,
            className: 'errorButton',
            onClick: () => setError(false),
          },
        },
      ]}
    />
  );
};

export default AlertPopup;
